module.exports = __webpack_public_path__ + "images/file_icons_v2/crx-68908f2a538412e831693d4d5695f130.svg";